import extend from 'lodash/extend';
import ObjectValidator from '@Components/Results/services/validation-helpers.factory';
import PropTypes from 'prop-types';

export default class StructureModel {
  constructor(data = {}) {
    this.validateData(data);
    extend(this, data);
  }

  validateData(data) {
    ObjectValidator.check(this.constructor.validationRules, data, 'StructureModel');
  }

  static validationRules = {
    databaseId: PropTypes.string,
    index: PropTypes.string,
    details: PropTypes.object,
    'details.id': PropTypes.string,
    'details.chemicalNames': PropTypes.array,

    'molImage.path': PropTypes.string,
  };
}
